<span data-e2e="snackbar" [ngClass]="{ 'mr-2': actionName }">{{
  message
}}</span>
@if (actionName) {
<span
  role="button"
  class="text-uppercase font-weight-bold"
  (click)="triggerAction()"
  [ngClass]="[this.actionTextClass]"
  >{{ actionName }}</span
>
}
